export const FACEBOOK_APP_ID = process.env.REACT_APP_FACEBOOK_APP_ID || '973176056074364'
export const FACEBOOK_FIELDS = 'id ,name ,first_name ,last_name ,gender ,installed ,verified ,email ,picture'
export const FACEBOOK_SCOPE = 'email, public_profile'

export const TURNSTILE_SITE_KEY = process.env.REACT_APP_TURNSTILE_SITE_KEY || '0x4AAAAAABe6wq3ZuGpcLJ-2'

export const TURNSTILE_CONTAINERS = {
  LOGIN_FORM: 'turnstile-container-login',
  SIGNUP_FORM: 'turnstile-container-signup',
  CLOSE_ANOTHER_SESSIONS: 'turnstile-container-sessions',
}

export const WHATSAPP_SUPPORT_URL =
  'https://wa.me/525552740236?text=Tengo%20problemas%20para%20iniciar%20sesión'

export const AUTH_MODAL_SPLASH_VIDEO_URL =
  process.env.REACT_APP_AUTH_SPLASH_VIDEO_URL || 'https://demo.pickwin.net/video/pickwin-splash.mp4'

export const MODAL_HOLD_STEPS = ['SMS_CONFIRMATION', 'COMPLETE_FACEBOOK_DATA']

export const getTurnstileContainerId = (loginStatus) =>
  TURNSTILE_CONTAINERS[loginStatus] || null

/** loginStatus del modal/flujo tiene prioridad sobre authPageStep de la página. */
export const resolveTurnstileStep = ({ authPageStep, loginStatus }) =>
  getTurnstileContainerId(loginStatus) ? loginStatus : authPageStep
